import { render, staticRenderFns } from "./VariableList.vue?vue&type=template&id=38792bbc&"
import script from "./VariableList.vue?vue&type=script&lang=ts&"
export * from "./VariableList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports